/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 4/9/14
 * Time: 8:22 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var template = require("manager-templates/data-sources/attributes/scraperView.tmpl");
    var BaseCollection = require("collections/BaseCollection");
    var ScraperItemView = require("manager-views/data-sources/attributes/ScraperItemView");
    var Button = require("ui/button/Button");
    var ManagerConfig = require("manager-assets/config/managerConfig.json");

    var ScraperView = {};
    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {
        ScraperView = Marionette.CompositeView.extend({
            template: template,
            itemView: ScraperItemView,
            itemViewContainer : ".scraper-list",
            ui: {
                "saveButton": ".button-save-edit",
                "footer": ".list-footer"
            },

            uiComponents: {
                saveBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        initState: Button.STATES.DISABLED
                    },
                    events: {
                        "click": "saveProperties"
                    }
                }
            },

            initialize: function (options) {
                LEManager.logger.debug("ScraperView:initialize");
                //the current collection. it is updated everytime a change is done in one of the properties (map by dropdown or the value textbox)
                this.vent = LEManager.media.channel("dataSources").vent;
                this.attributeModel = options.attributeModel;
                this._bindEvents();
            },

            _bindEvents: function(){
                this.listenTo(this.collection, 'change', this.collectionChanged);
                this.listenTo(this.vent,ManagerConfig.dataSources.mainConfig.scraper.TRIGGERING.SCRAPER_SAVE_DONE,this.onScraperSaveDone, this);
            },

            onRender: function(){
                LEManager.logger.debug("ScraperView:onRender");
                this.positionSaveButton();
            },

            positionSaveButton: function(){
                LEManager.logger.debug("ScraperView:positionSaveButton");
                var numberOfEditableRows = this.collection.getNumberOfEditableProperties();
                var totalRows = this.collection.length;
                var top = 0 - (totalRows * ManagerConfig.dataSources.mainConfig.scraper.rowHeight) + (numberOfEditableRows * ManagerConfig.dataSources.mainConfig.scraper.rowHeight);
                LEManager.logger.debug("ScraperView:positionSaveButton - top: " + top);
                $(this.ui.footer).css("top", top + "px");
            },

            onScraperSaveDone: function(result){
                LEManager.logger.debug("ScraperView:onScraperSaveDone - result.isSuccess: " + result.isSuccess);
                if (result.isSuccess){
                    //we disable the specific clicked save button and ventually clean errors after a successfull save
                    if (!_.isUndefined(result.model) && result.model.id === this.attributeModel.id){
                        this.uiComponents.saveBtn.setState(Button.STATES.DISABLED);
                        LEManager.logger.debug("ScraperView:onScraperSaveDone - before clearing all childViews errors");
                        this.children.each(function(itemView){
                            itemView.clearErrors();
                        });
                    }
                }
            },

            collectionChanged: function(model){
                LEManager.logger.debug("ScraperView:collectionChanged");
                var currentState = this.uiComponents.saveBtn.getState();
                if (currentState === Button.STATES.DISABLED && model.hasScrapingPropertyChanges()){
                    this.uiComponents.saveBtn.setState(Button.STATES.ENABLED);
                }
            },

            saveProperties: function(){
                LEManager.logger.debug("ScraperView:saveProperties");
                if (this.validatePropertiesByModel()){//validation is ok. save can be performed
                    this.vent.trigger(ManagerConfig.dataSources.mainConfig.scraper.TRIGGERING.SCRAPER_SAVE, this.attributeModel);
                }
                else {
                    LEManager.logger.info("ScraperView:saveProperties - model is not valid - showing error notification");
                    LEManager.notifier.showError({
                        content: LE.translator.translate("LEManager.manager.dataSources.edit.validation.error")});
                }
            },

            validatePropertiesByModel: function(){
                LEManager.logger.debug("ScraperView:validatePropertiesByModel");
                var result = this.collection.areModelsValid();
                LEManager.logger.debug("ScraperView:validatePropertiesByModel - result: " + result);
                return result;
            },

            onClose: function() {
                this.stopListening(this.collection);
                LEManager.logger.debug("ScraperView:onClose");
            }
        });
    });
    return ScraperView;
});

